import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centro_informacion',
  templateUrl: './centro_informacion.component.html',
  styleUrls: ['./centro_informacion.component.css']
})
export class Centro_informacionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
